import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { invoiceColors, type InvoiceStatus } from '@/lib/invoices';

export function InvoiceBadge({ status, director }: { status?: InvoiceStatus | string | null; director?: boolean }) {
  const { t } = useTranslation();
  if (!status) return <span className="text-xs text-muted-foreground">—</span>;
  const key = director ? `invoice.director_status.${status}` : `invoice.status.${status}`;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap', invoiceColors[status as InvoiceStatus] ?? 'bg-muted text-muted-foreground')}>
      {t(key, { defaultValue: status })}
    </span>
  );
}
